import { LoadingRow } from '../../Row/LoadingRow'

const CHILDREN_LOADING_ROWS = 3

export const ChildrenLoading = ({ level }: { level: number }) => {
  return Array.from({ length: CHILDREN_LOADING_ROWS }).map((_, index) => (
    <LoadingRow key={index} level={level} />
  ))
}
